export const SUBSCRIBE_TOAST_SUCCESS_TEXT = "alerts.subscription.toast.success";
export const UPDATE_SUBSCRIPTION_TEXT = "bt.subscribe.toast.changes.success";
export const UNSUBSCRIBE_TOAST_SUCCESS_TEXT = "alerts.subscription.toast.unsubscribe";
